























































import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'

settings =
  name: "UnsubmittedOfferCard"

  vue:
    props: ['offer', 'activations', 'resourceComponent']

    data: ->
      appliedActivationsForSpaceName: {} # spaceName: activationId

    mounted: ->
      @loadAppliedActivations()

    computed:
      emptyActivations: -> !@activations?.length

    methods:
      loadAppliedActivations: ->
        appliedActivations = {}
        for spaceName, activation of @offer.activations_applied
          appliedActivations[spaceName] = activation.activation_id
        @appliedActivationsForSpaceName = appliedActivations

      navigateToDetails: ->
        @$router.push({ name: 'CheckoutOfferDetails', params: { offerId: @offer.id, tab: 'overview' } })

      lauchActivationTypeform: ->
        typeformUrl = encodeURI("https://teamrecess.typeform.com/to/l3ugIw?email=#{@currentMember().email}&user_id=#{@currentMember().id}&company=#{@currentMember().sponsor.name}&first_name=#{@currentMember().brand_rep.first_name}&last_name=#{@currentMember().brand_rep.last_name}&phone=#{@currentMember().brand_rep.phone}")
        window.open(typeformUrl, '_new_activation')

      hiApplyActivationTrigger: (spaceName) ->
        payload =
          offer_id: @offer.id
          activations_applied: {}

        payload.activations_applied[spaceName] =
          activation_id: @appliedActivationsForSpaceName[spaceName]

        @resourceComponent.hiApplyActivationTrigger(payload)

      activationIsApplied: (spaceName) ->
        !!@offer.activations_applied[spaceName].activation_name

export default VueOptions.vue settings
